import { useContext, useEffect, useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import { UseCasesContext } from "../../../../context/useCases"
import { FiledType, Form } from "../../../components/form"
import { Menu } from "../../../components/menu"

export const AmofileAdd = () => {
    const navigate = useNavigate();
    const [error, setError] = useState<string>("")

    let useCases = useContext(UseCasesContext)
    const [form, setForm] = useState<{
        leadUrl: string,
        file: File[],
    }>({
        leadUrl: "",
        file: [],
    })

    const submit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        if (form.file !== null && form.leadUrl !== "") {
            let id = getIdFromUrl(form.leadUrl)
            if (!id) {
                setError("не удается получить id из ссылки на лид, пожалуйста проверьте ссылку")
                return
            } else {
                setError("")
            }
            useCases?.amofileUseCase.CreateAmofile(id, form.file!, () => { navigate(-1) })
        }
    }

    const getIdFromUrl: (url: string) => number = (url: string) => {
        const parsedUrl = new URL(url)
        let items = parsedUrl.pathname.split('/')
        let id = parseInt(items[items.length -1 ])
        return id
    }

    const updateForm = (name: string, value: any) => {
        setForm({
            ...form,
            [name]: value,
        })
    }

    const formatDate = (day: Date) => {
        const yyyy = day.getFullYear();
        let mm = (day.getMonth() + 1).toString(); // Months start at 0!
        let dd = day.getDate().toString();

        if (dd.length == 1) dd = '0' + dd;
        if (mm.length == 1) mm = '0' + mm;

        return dd + '.' + mm + '.' + yyyy;
    }

    return (
        <div className="layout-page" >
            <Menu />
            <div className="content-wrapper" >
                <div className="container-xxl flex-grow-1 container-p-y">
                    <div className="row mx-1">
                        <div className="col-sm-12 col-md-12">
                            <h4 className="fw-bold py-3 mb-4"><span className="text-muted fw-light">Файл /</span> Добавить файл</h4>
                        </div>
                        <div className="card">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">Добавление файла amocrm</h5>
                            </div>
                            <div className="card-body">
                                {error!== ""?<div className="alert alert-danger" role="alert">Ошибка добавления: {error}</div>:<></>}
                                <Form
                                    state={{
                                        loading: false,
                                        error: "",
                                    }}

                                    submit={submit}

                                    fields={[
                                        {
                                            name: "leadUrl",
                                            title: "Ссылка в AmoCrm",
                                            placeholder: "Укажите ссылку на лид в AmoCrm",
                                            value: form.leadUrl,
                                            type: FiledType.Text,
                                        },
                                        {
                                            name: "file",
                                            title: "Файл",
                                            placeholder: "Прикрепите файл",
                                            value: form.file,
                                            type: FiledType.File,
                                        },
                                    ]}
                                    btnSmall={true}
                                    submitBtnTitle={"Загрузить"}
                                    updateForm={updateForm}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
